import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

const ProtectedRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  // Not authenticated - redirect to login
  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}/login`}
        replace
        state={{ from: location }}
      />
    );
  }

  // Authenticated - allow access
  return <Outlet />;
};

export default ProtectedRoute;
